import React, { useMemo } from "react";
import GradeSimpleDetail from "./GradeSimpleDetails";
import "../styles.css";
import RenderGradeSummarySwitch from "./RenderGradeSummarySwitch";
import { Divider } from "@mui/material";

export const order = [
  "Sum Insured",
  "Co Payment",
  "Room Rent Limit",
  "Maternity Coverage",
  "Ambulance Charges",
  "OPD Charges",
  "Health Checkup Coverage",
  "Dental Coverage",
  "Disease Wise Sub-limit",
  "Critical Illness Coverages",
  "UNANI Coverages",
  "Congenital Internal Disease Coverage",
  "Critical External Disease Coverage",
];

const GradeSummaryDetail = ({ gradeData, productIdName, isFlat }) => {
  const sortedProducts = useMemo(() => {
    const normalizedOrder = order.map((item) => item.trim());

    // Map to normalize space and trim in input array for matching
    const mappedArr = productIdName.map((subArr) => [
      subArr[0],
      subArr[1].trim(),
    ]);

    return mappedArr.sort((a, b) => {
      // Find the index of the elements in the order array
      const indexA = normalizedOrder.indexOf(a[1]);
      const indexB = normalizedOrder.indexOf(b[1]);

      return indexA - indexB;
    });
  }, [productIdName]);
  return (
    <section
      style={{
        padding: "0px 16px",
      }}
    >
      {!isFlat && (
        <Divider style={{ marginTop: "-20px", marginBottom: "30px" }} />
      )}
      {/* {gradeData && gradeData.grade_code && (
        <GradeSimpleDetail
          title="Grade Code"
          text={`${gradeData.grade_code}`}
        />
      )} */}
      {sortedProducts &&
        sortedProducts.map(([id, name], index) => {
          const attributeDetails =
            gradeData.grade_attributes_data &&
            gradeData.grade_attributes_data.find(
              (obj) => obj.attribute_product_mapping === id
            );
          return (
            <RenderGradeSummarySwitch
              name={name}
              attributeData={attributeDetails}
              grade={gradeData}
              key={index}
            />
          );
        })}
      {gradeData.other_details && (
        <GradeSimpleDetail
          title="Other Details"
          text={`${gradeData.other_details}`}
        />
      )}

      {/* <footer className="footer-btn">
        <div>
          <LargeButton
            style={{
              backgroundColor: "transparent",
              border: `1px solid ${colors.primaryColor}`,
              color: colors.primaryColor,
              padding: "0px",
            }}
            label="Delete"
          />
          <LargeButton label="Edit" />
        </div>
      </footer> */}
    </section>
  );
};

export default GradeSummaryDetail;
